'use strict';
export class InfoblockGallery {
	constructor(component_id) {
		this.id = component_id;
		this.vars = yalwa.v.components[this.id];
		this.$root = jQuery(`.js-${this.id}`);
		this.$edit = this.$root.find(`.js-${this.id}_edit`);
		this.$info_btn = this.$root.find(`.js-${this.id}_suffix_icon`);
		this.$badge_btn = this.$root.find(`.js-${this.id}_prefix_icon`);
		this.dialog_id = this.vars.dialog_id;
		//Init Dialog
		
	}
	
	init() {
		this.$edit.on('click', () => {
			jQuery('html').addClass('js-no_scroll');
			
			jQuery(`.js-${this.dialog_id}`).appendTo('body');
			yalwa.v.component_instances[this.dialog_id].show();
		});
		
		this.$badge_btn.on('click', () => {
			jQuery(`.js-dialog_purchasevip`).appendTo('body');
			yalwa.v.component_instances['dialog_purchasevip'].show();
		});
		this.$info_btn.on('click', () => {
			const guideDialog = yalwa.v.component_instances['dialog_vipguidewhy'];
			if (guideDialog) {
				document.dispatchEvent(new CustomEvent('vip_guide_dialog_view', {
					detail: { view: 'checklist', bit: 1 }
				}));
				jQuery('.js-dialog_vipguidewhy').appendTo('body');
				guideDialog.show();
				return;
			}

			jQuery(`.js-dialog_infoicon`).appendTo('body');
			yalwa.v.component_instances['dialog_infoicon'].show();
			
			jQuery('html').addClass('js-no_scroll');
			//Init Slider
			const slide_options = {
				css_prefix:'infocard__',
				timeout:5000,
				container_class: 'js-simple_auto_slide_vipinfo',
				bullets : {container_class: 'js-slider_vipinfo_pagination_container'},
				clickable : false,
			};
			this.pf_info_slider = new yalwa.basics.simple_auto_slide(slide_options);
			this.pf_info_slider.start();
			
			//Mobile
			if (window.innerWidth <= 765) {
				jQuery('.js-slider_vipinfo_pagination_container').appendTo('.js-pagination_header');
			}
		});
	}
}